import { AppStateFailure } from './app-state.failure.model';
import { AppStateFailureItemWithErrorCode } from './app-state-errorcode.failure';

export function firstFailureItem(
  failureState: AppStateFailure
): AppStateFailureItemWithErrorCode {
  if (!failureState.failures) {
    throw new Error('No failure items.');
  }
  return failureState.failures[0];
}
